import { UI } from "../constants/tokens";
import LTR from "./LTR";

// Single source of truth for the "this symbol is on your books" badge.
// Renders nothing when the symbol is neither in portfolio nor watchlist —
// callers can drop it into any row without a guard.
//
// Portfolio wins over watchlist: a symbol the user actually owns is labeled
// "בתיק שלך", even if it's also on the watchlist. Watchlist-only symbols get
// the softer "במעקב שלך" so the label stays factually correct.
export default function HoldingBadge({ symbol, portfolio = [], watchlist = [], isHe = true, withSymbol = false }) {
  if (!symbol) return null;
  const inPortfolio = portfolio.some(p => p.symbol === symbol);
  const inWatchlist = !inPortfolio && watchlist.some(w => w.symbol === symbol);
  if (!inPortfolio && !inWatchlist) return null;

  const baseLabel = inPortfolio
    ? (isHe ? "בתיק שלך" : "In your portfolio")
    : (isHe ? "במעקב שלך" : "On your watchlist");

  return (
    // The selected plate, so "this one is yours" carries the same weight as
    // every other "chosen" state in the product and is legible at a glance —
    // it used to be an 11px grey chip that disappeared into the row.
    <span style={{
      fontSize: 11.5, fontWeight: 800,
      color: UI.state.fg, background: UI.state.surface,
      borderRadius: 999, padding: "3px 9px", whiteSpace: "nowrap",
    }}>
      {baseLabel}
      {withSymbol && <> · <LTR>{symbol}</LTR></>}
    </span>
  );
}
